<template>
	<div class="app-card">
		<div v-if="hasHeader" class="app-card__header">
			<slot name="header" />
		</div>

		<div class="app-card__content">
			<slot />
		</div>

		<div v-if="hasFooter" class="app-card__footer">
			<slot name="footer" />
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { useHasSlot } from '@/composables';

export default defineComponent({
	setup(props, { slots }) {
		return {
			hasHeader: useHasSlot('header', slots),
			hasFooter: useHasSlot('footer', slots),
		};
	},
});
</script>

<style lang="scss">
.app-card {
	@include heading-3;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	min-height: 32rem;
	padding: 1.8rem 2.1rem 2.4rem;
	border-radius: 0.8rem;
	border-radius: 0.8rem;
	background: $color-white;

	&__header {
		display: flex;
		width: 100%;
		padding-bottom: 1.5rem;
	}

	&__footer {
		display: flex;
		width: 100%;
		margin-top: auto;
		padding-top: 1.5rem;
	}
}
</style>
